import { useEffect } from "react";

import {
  fetchCurrentSessionInformation,
  saveVisitInfo
} from "@/redux/features/visits-logging/thunk";
import { useAppSelector, useAppDispatch } from "@/redux/store/hooks";

const useVisitsLogging = () => {
  const dispatch = useAppDispatch();

  const { pageType, pageId, itemType, itemId } = useAppSelector(
    (state) => state.visitsLogging.pageData
  );

  useEffect(() => {
    async function logVisits() {
      await dispatch(fetchCurrentSessionInformation());

      const visitInfo = {
        pageType,
        pageId: Number(pageId),
        itemType,
        itemId: Number(itemId),
        visitedUrl: window.location.href,
        // eslint-disable-next-line no-undef
        userAgent: navigator.userAgent
      };
      dispatch(saveVisitInfo(visitInfo));
    }

    pageId && logVisits();
  }, [dispatch, itemId, itemType, pageId, pageType]);
};

export default useVisitsLogging;
